import PropTypes from 'prop-types';
export const subscriptionPropType = PropTypes.shape({
  daysRemaining: PropTypes.number.isRequired,
  endDate: PropTypes.string.isRequired,
  offeringCategory: PropTypes.string.isRequired,
  offeringCategoryName: PropTypes.string.isRequired,
  offeringCategoryRanking: PropTypes.number.isRequired,
  offeringExternalKey: PropTypes.string.isRequired,
  offeringName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
});
export const userPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  analyticsId: PropTypes.string
});
export const bannerMessagePropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  daysLeft: PropTypes.number.isRequired
});
//# sourceMappingURL=types.js.map